import styled from 'styled-components'

export default styled.h1`
  margin: 0;
  padding: 0;
`



// WEBPACK FOOTER //
// ./src/components/App/Title.js